import {TableRow} from 'platform/components';
import {Box, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {LEASING_ANNUAL_MILEAGES, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {LeasingCellCoordinates} from '../types/LeasingCellCoordinates';
import {findLeasingCell} from '../utils/findLeasingCell';
import {isActiveLeasingCell} from '../utils/isActiveLeasingCell';
import {LeasingMatrixRowCell} from './LeasingMatrixRowCell';

interface LeasingMatrixRowProps {
  vehicleLeasingBody: SaveSaleVehicleLeasingBody;
  term: number;
  isReadOnly: boolean;
  onEditCell: (coordinates: LeasingCellCoordinates) => void;
}

export function LeasingMatrixRow(props: LeasingMatrixRowProps) {
  return (
    <TableRow hoverColor="general.transparent">
      <Box paddingHorizontal={1} paddingTop={1}>
        <VStack height={15} align="center" justify="center">
          <Text size="xSmall" color="secondary">
            {i18n.t('page.vehicle.financingAndLeasing.monthsValue', {term: props.term})}
          </Text>
        </VStack>
      </Box>
      {LEASING_ANNUAL_MILEAGES.map((annualMileage) => {
        const cellCoordinates = {term: props.term, annualMileage};
        const cell = findLeasingCell(props.vehicleLeasingBody.rateMatrixCells, cellCoordinates);
        const isActive =
          isNotNil(cell) && isActiveLeasingCell(props.vehicleLeasingBody, cellCoordinates);

        return (
          <LeasingMatrixRowCell
            key={annualMileage}
            term={props.term}
            annualMileage={annualMileage}
            cell={cell}
            isActive={isActive}
            isReadOnly={props.isReadOnly}
            onEditCell={props.onEditCell}
          />
        );
      })}
    </TableRow>
  );
}
